import { GALLERY_CONSTS, } from 'pro-gallery-lib';
export function getItemsInViewportOrMarginByActiveGroup(_a) {
    var groups = _a.groups, options = _a.options, virtualizationSettings = _a.virtualizationSettings, galleryWidth = _a.galleryWidth, galleryHeight = _a.galleryHeight, activeIndex = _a.activeIndex;
    var _b = virtualizationSettings || {}, _c = _b.enabled, enabled = _c === void 0 ? false : _c, _d = _b.forwardItemMargin, forwardItemMargin = _d === void 0 ? 3 : _d, _e = _b.backwardItemMargin, backwardItemMargin = _e === void 0 ? 3 : _e, _f = _b.forwardItemScrollMargin, forwardItemScrollMargin = _f === void 0 ? 10 : _f, _g = _b.backwardItemScrollMargin, backwardItemScrollMargin = _g === void 0 ? 10 : _g;
    var isHorizontal = options.scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL;
    var isScrollable = !isHorizontal ||
        options.slideAnimation === GALLERY_CONSTS.slideAnimations.SCROLL;
    var getFallbackGroups = function () {
        return groups.map(function (group) { return ({
            group: group,
            shouldRender: true,
        }); });
    };
    if (!enabled) {
        return getFallbackGroups();
    }
    try {
        var size = isHorizontal ? galleryWidth : galleryHeight;
        var unit = isHorizontal ? 'width' : 'height';
        var rightRenderBuffer = isScrollable
            ? forwardItemScrollMargin
            : forwardItemMargin;
        var leftRenderBuffer = isScrollable
            ? backwardItemScrollMargin
            : backwardItemMargin;
        var activeGroupIndex = groups.findIndex(function (group) {
            var _a, _b;
            var items = group.items;
            var first = items[0];
            var last = items[items.length - 1];
            var firstIndex = (_a = first.idx) !== null && _a !== void 0 ? _a : first.fullscreenIdx;
            var lastIndex = (_b = last.idx) !== null && _b !== void 0 ? _b : last.fullscreenIdx;
            return firstIndex <= activeIndex && lastIndex >= activeIndex;
        });
        var activeGroup = groups[activeGroupIndex];
        var activeGroupPrecOfScreen = activeGroup[unit] / size;
        var accoumilatedRightMargin = activeGroupPrecOfScreen;
        var accoumilatedLeftMargin = activeGroupPrecOfScreen;
        var groupsToRender_1 = [activeGroup];
        for (var index = 1; accoumilatedRightMargin < rightRenderBuffer ||
            accoumilatedLeftMargin < leftRenderBuffer; index++) {
            var groupToRight = groups[activeGroupIndex + index];
            var groupToLeft = groups[activeGroupIndex - index];
            if (groupToRight && accoumilatedRightMargin < rightRenderBuffer) {
                var groupPrecOfScreen = groupToRight[unit] / size;
                accoumilatedRightMargin += groupPrecOfScreen;
                groupsToRender_1.push(groupToRight);
            }
            if (groupToLeft && accoumilatedLeftMargin < leftRenderBuffer) {
                var groupPrecOfScreen = groupToLeft[unit] / size;
                accoumilatedLeftMargin += groupPrecOfScreen;
                groupsToRender_1.push(groupToLeft);
            }
            if (!groupToLeft && !groupToRight) {
                break;
            }
        }
        return groups.map(function (group) {
            return { group: group, shouldRender: groupsToRender_1.includes(group) };
        });
    }
    catch (error) {
        console.error('pro-gallery could virtualize groups: ', error);
        return getFallbackGroups();
    }
}
export function getItemsInViewportOrMarginByScrollLocation(_a) {
    var items = _a.items, options = _a.options, virtualizationSettings = _a.virtualizationSettings, galleryWidth = _a.galleryWidth, galleryHeight = _a.galleryHeight, scrollPosition = _a.scrollPosition;
    var _b = virtualizationSettings || {}, _c = _b.enabled, enabled = _c === void 0 ? false : _c, _d = _b.forwardItemScrollMargin, forwardItemScrollMargin = _d === void 0 ? 10 : _d, _e = _b.backwardItemScrollMargin, backwardItemScrollMargin = _e === void 0 ? 10 : _e;
    var getFallbackItems = function () {
        return items.map(function (item) { return ({
            item: item,
            shouldRender: true,
        }); });
    };
    if (!enabled) {
        return getFallbackItems();
    }
    try {
        var isHorizontal = options.scrollDirection === GALLERY_CONSTS.scrollDirection.HORIZONTAL;
        var size_1 = isHorizontal ? galleryWidth : galleryHeight;
        var unit_1 = isHorizontal ? 'width' : 'height';
        var shouldRenderItem_1 = function (item) {
            var group = item.group;
            var locationUnit = unit_1 === 'height' ? 'top' : 'left';
            var location = group[locationUnit];
            var locationEnd = location + group[unit_1];
            var viewportStart = scrollPosition - size_1 * backwardItemScrollMargin;
            var viewportEnd = scrollPosition + size_1 * forwardItemScrollMargin;
            return location > viewportStart && locationEnd < viewportEnd;
        };
        return items.map(function (item) { return ({
            item: item,
            shouldRender: shouldRenderItem_1(item),
        }); });
    }
    catch (error) {
        console.error('pro-gallery could virtualize items: ', error);
        return getFallbackItems();
    }
}
//# sourceMappingURL=virtualization.js.map